export class LinkedInUserCancelledLogin extends Error {
	constructor() {
		super('User declined to log in the their linkedin account');
		this.name = 'LinkedInUserCancelledLogin';
	}
}
